// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__NBdTk","productName":"Table_productName__399uO"};